import util from "@/helpers/util";

export class DealDetails {
    DealID: number = 0;
    Title: string = '';
    Description: string = '';
    ImgUrl: string = '';
    RetailPrice?: number;
    DealPrice?: number;
    DealURL: string = '';
    DealShortURL: string = '';
    DealProvider: string = '';
    IsActive: boolean = false;
    IsArchived: boolean = false;
    InsertDate?: Date;
    UpdateDate?: Date;
    ProductID: string = '';
    Tag: string = '';
    isExpired: boolean = false;
    PromoCode: string = '';
    isSoldOut?: boolean;
    PrettyTitle: string = '';
    PrettyDesc: string = '';
    PercentOff: number | null = null;

    //FRONT END ONLY
    expirationMessage?: string;
    adType?: string;
    adContent?: string;

    constructor(partial?: Partial<DealDetails>) {
        Object.assign(this, partial);
    }

    hasPrice(): boolean {
        return util.hasValue(this.DealPrice) && this.DealPrice > -0.01
    }
}